import React from "react";
import "./puja-campaign-time-loader.scss";

export default function TimeLoader() {
  return (
    <div className={`flex-row-center PujaCampaignTimerLoader`}>
      <div className="timeLoader"></div>
    </div>
  );
}
